export const LANDING_STEP_LABEL = 'Landing';
export const TERMS_STEP_LABEL = 'Terms';
export const PERSONAL_INFO_STEP_LABEL = 'Personal Info';
export const REVIEW_STEP_LABEL = 'Review';
export const KIQ_ONBOARDING_STEP_LABEL = 'Questions Onboarding';
export const KIQ_STEP_LABEL = 'Questions';
export const SUCCESS_STEP_LABEL = 'Success';
export const ERROR_STEP_LABEL = 'Error';

export const GENERIC_ERROR_SUBSTEP = 'generic-error';
export const GENERIC_ERROR_SUBSTEP_LABEL = 'GenericError';
export const USER_NOT_FOUND_SUBSTEP = 'user-not-found';
export const USER_NOT_FOUND_SUBSTEP_LABEL = 'UserNotFound';
export const USER_NOT_FOUND_LOCKED_OUT_SUBSTEP = 'user-not-found-locked-out';
export const USER_NOT_FOUND_LOCKED_OUT_SUBSTEP_LABEL = 'UserNotFoundLockedOut';
export const USER_LOCKED_OUT_SUBSTEP = 'user-locked-out';
export const USER_LOCKED_OUT_SUBSTEP_LABEL = 'UserLockedOut';
export const INCORRECT_ANSWERS_SUBSTEP = 'incorrect-answers';
export const INCORRECT_ANSWERS_SUBSTEP_LABEL = 'IncorrectAnswers';
export const FROZEN_ACCOUNT_SUBSTEP = 'frozen-account';
export const FROZEN_ACCOUNT_SUBSTEP_LABEL = 'FrozenAccount';
export const FROZEN_ACCOUNT_WARNING_SUBSTEP = 'frozen-account-warning';
export const FROZEN_ACCOUNT_WARNING_SUBSTEP_LABEL = 'FrozenAccountWarning';
export const FORBIDDEN_IP_SUBSTEP = 'forbidden-ip';
export const FORBIDDEN_IP_SUBSTEP_LABEL = 'ForbiddenIp';
export const THIN_CREDIT_FILE_SUBSTEP = 'thin-credit-file';
export const THIN_CREDIT_FILE_SUBSTEP_LABEL = 'ThinCreditFile';
